import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProfile } from './helper/UserProfile';
import { RevalidationDataProvider } from './helper/UserRevalidationProgress';
import ScrollToTop from './helper/ScrollToTop';

import Header from './Header';
import Profile from './pages/Profile';
import Competencies from './pages/Competencies';
import Login from './pages/Login';
import Home from './pages/Home';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Revalidation from './pages/revalidation/Revalidation';
import Navigation from './pages/Navigation';
import DashboardMain from './pages/DashboardMain';
import RevalidationDocuments from './pages/revalidation/Documents';
import RevalidationProfile from './pages/revalidation/Details';
import Signup from './pages/Signup';
import Gold from './pages/revalidation/Gold';
import Diamond from './pages/revalidation/Diamond';
import Platinum from './pages/revalidation/Platinum';
import CPD from './pages/revalidation/CPD';
import PHL from './pages/revalidation/PHL';
import ReflectiveAccount from './pages/revalidation/ReflectiveAccount';
import FeedbackLog from './pages/revalidation/FeedbackLog';
import Confirmation from './pages/revalidation/Confirmation';
import Support from './pages/Support';
import RequestPassword from './pages/RequestPassword';
import ResetPassword from './pages/ResetPassword';
import PendingApproval from './pages/PendingApproval';
import Courses from './pages/Courses';

import MobileProfile from './pages/mobile/MobileProfile';

import Wrapper from './helper/Wrapper';
import RevalidationWrapper from './helper/RevalidationWrapper';


function App() {
  return (
    
    <Router>
      <ScrollToTop />
      <Routes>
        /* General Pages */
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/navigation" element={<UserProfile><Navigation /></UserProfile>} />
        <Route path="/header" element={<Header />} />
        <Route path="/password" element={<RequestPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />


        /* Dashboard Layout with Nested Routes */
        <Route path="/dashboard" element={<UserProfile><Wrapper><Dashboard /></Wrapper></UserProfile>}>
          <Route index element={<UserProfile><Wrapper><DashboardMain /></Wrapper></UserProfile>} />
          <Route path="main" element={<DashboardMain />} />
          <Route path="profile" element={<UserProfile><Profile /></UserProfile>} />
          <Route path="mobile-profile" element={<UserProfile><MobileProfile /></UserProfile>} />
          <Route path="competencies" element={<Competencies />} />
          <Route path="signup" element={<Signup />} />
          <Route path="support" element={<Support />} />
          <Route path="pendingApproval" element={<PendingApproval />} />
          <Route path="courses" element={<Courses />} />

          <Route path="revalidation" element = {<RevalidationWrapper><RevalidationDataProvider><Revalidation /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="revalidationCpd" element={<RevalidationWrapper><RevalidationDataProvider><CPD /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="details" element = {<RevalidationWrapper><RevalidationProfile /></RevalidationWrapper>} />
          <Route path="revalidationDocuments" element={<RevalidationWrapper><RevalidationDataProvider><RevalidationDocuments /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="revalidationPhl" element={<RevalidationWrapper><RevalidationDataProvider><PHL /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="revalidationReflectiveAccount" element={<RevalidationWrapper><RevalidationDataProvider><ReflectiveAccount /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="revalidationFeedback" element={<RevalidationWrapper><RevalidationDataProvider><FeedbackLog /></RevalidationDataProvider></RevalidationWrapper>} />
          <Route path="revalidationConfirmation" element={<RevalidationWrapper><RevalidationDataProvider><Confirmation /></RevalidationDataProvider></RevalidationWrapper>} />

          <Route path="gold" element={<RevalidationWrapper><Gold /></RevalidationWrapper>} />
          <Route path="platinum" element={<RevalidationWrapper><Platinum /></RevalidationWrapper>} />
          <Route path="diamond" element={<RevalidationWrapper><Diamond /></RevalidationWrapper>} />
        </Route>
       </Routes>
    </Router>
  );
}

export default App;